import React from 'react';
import { useWebMCP } from 'usewebmcp';
import { executeGetLeonardoUrl } from './executors/getLeonardoUrl';
import { LEONARDO_URL_INPUT_SCHEMA } from './schemas/inputSchemas';

export const LeonardoUrlTool: React.FC = () => {
  useWebMCP({
    name: 'get_leonardo_url',
    description:
      'Build a Leonardo web app share URL for a contrast-first theme based on a base color. Use when someone wants to open or edit the palette in Adobe Leonardo after generating or discussing a scale.',
    inputSchema: LEONARDO_URL_INPUT_SCHEMA,
    annotations: { readOnlyHint: true },
    execute: executeGetLeonardoUrl,
  });

  return null;
};
